<template>
  <el-dialog
    :title="title"
    width="1024px"
    :visible.sync="visible"
    append-to-body
    class="chose-from-vod-dialog dialog-index-max"
  >
    <div style="position: relative">
      <div
        class="flex-align-center"
        style="
          width: 100%;
          margin-bottom: 10px;
          justify-content: right;
          padding-right: 10px;
        "
      >
        <div style="display: flex; align-items: center">
          <span
            style="margin-right: 20px; color: #556ee6; cursor: pointer"
            v-if="showBack"
            @click="backDir"
            >&lt;返回上一级</span
          >
          <el-radio
            v-model="path"
            v-if="showImage"
            label="/image"
            style="margin-top: 7.25px"
            @change="changeType('image')"
            >图片</el-radio
          >
          <el-radio
            v-model="path"
            v-if="showVideo"
            label="/video"
            style="margin-top: 7.25px"
            @change="changeType('video')"
            >视频</el-radio
          >
          <el-radio
            v-model="path"
            v-if="showAudio"
            label="/audio"
            style="margin-top: 7.25px"
            @change="changeType('audio')"
            >音频</el-radio
          >
          <!-- <el-checkbox
            v-model="justMine"
            style="margin-top: 5px; margin-right: 15px"
            @change="getList"
            >只看我的</el-checkbox
          > -->
          <b-form-input
            v-model="pageParams.content"
            class="w-190 m-r-10"
            size="sm"
            type="text"
            placeholder="请输入搜索内容"
            @keydown.enter="search"
          ></b-form-input>
          <b-button class="m-r-5" size="sm" variant="primary" @click="search">
            <i class="bx bx-search-alt-2 font-size-16 align-middle"></i>
            搜索
          </b-button>
          <b-button
            size="sm"
            variant="outline-secondary"
            @click="resetParams()"
          >
            <i class="bx bx-revision font-size-16 align-middle"></i>
            重置
          </b-button>
        </div>
      </div>

      <div style="position: relative">
        <div
          style="
            position: absolute;
            width: 966px;
            height: 100%;
            top: 0;
            left: 0;
            z-index: 10;
            background-color: rgba(0, 0, 0, 0.1);
          "
          class="flex-center"
          v-if="showLoading"
        >
          <t-loading />
        </div>
        <div
          style="
            position: absolute;
            width: 966px;
            height: 100%;
            top: 0;
            left: 0;
            z-index: 5;
            color: gray;
            font-size: 20px;
          "
          class="flex-center"
          v-if="noDate"
        >
          <span>暂无上传文件</span>
        </div>
        <div
          style="
            display: flex;
            justify-content: center;
            width: 100%;
            overflow: auto;
            height: calc(90vh - 230px);
            position: relative;
          "
        >
          <div class="chose-from-vod-wrap">
            <div
              v-for="(item, index) in list"
              class="chose-from-vod-img-wrap"
              :key="index"
              style="margin: 5px"
            >
              <div
                style="
                  width: 128px;
                  height: 72px;
                  position: absolute;
                  top: 0;
                  left: 0;
                  cursor: pointer;
                "
                @click="viewItem(item)"
                class="flex-center"
                v-if="item.type == 'audio' || item.type == 'video'"
              >
                <PlayCircleStrokeIcon size="30px" color="white" />
              </div>
              <div
                v-if="item.type == 'dir'"
                style="
                  width: 128px;
                  height: 72px;
                  font-size: 100px;
                  overflow: hidden;
                  padding-left: 14px;
                  cursor: pointer;
                "
                class="flex-align-center"
                @click="openDir(item)"
              >
                <i
                  class="mdi mdi-folder text-warning"
                  v-if="item.type == 'dir'"
                ></i>
              </div>
              <img
                :src="item.type == 'image' ? item.url : item.coverUrl"
                style="width: 128px; height: 72px; cursor: pointer"
                @click="viewItem(item)"
                v-if="
                  (item.type == 'image' && item.url) ||
                    (item.type != 'image' && item.coverUrl)
                "
              />
              <div
                v-if="
                  ((item.type == 'image' && !item.url) ||
                    (item.type != 'image' && !item.coverUrl)) &&
                    item.type != 'dir'
                "
                style="
                  width: 128px;
                  height: 72px;
                  cursor: pointer;
                  background-color: black;
                "
              ></div>
              <span
                style="
                  display: flex;
                  width: 128px;
                  text-align: center;
                  margin-top: 3px;
                  align-items: center !important;
                  justify-content: center;
                "
              >
                <el-radio
                  v-model="radio"
                  v-if="isRadio && item.type != 'dir'"
                  :label="item"
                  >{{ item.title }}</el-radio
                >
                <span
                  v-if="item.type == 'dir'"
                  style="display: inline-block; with: 100%; font-size: 12px"
                  >{{ item.title }}</span
                >
                <!-- <b-form-radio v-model="radio" :value="index">{{
              item.title
            }}</b-form-radio> -->
                <b-form-checkbox
                  v-if="!isRadio && item.type != 'dir'"
                  v-model="multiple"
                  :value="item"
                  checked
                  plain
                >
                  {{ item.title }}
                </b-form-checkbox>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <span slot="footer">
      <div
        style="
          display: flex;
          align-items: center;
          width: 100%;
          justify-content: flex-end;
        "
      >
        <pagination
          :isBatch="false"
          :total="pageTotal"
          :pageSize="pageParams.pageSize"
          :page.sync="pageParams.page"
          @pageCallback="pageCallback"
          ref="page"
          style="margin-right: 30px; width: 700px"
          layout="total, prev, pager, next"
        ></pagination>
        <el-button
          style="margin-left: 10px"
          @click="visible = false"
          size="mini"
          >取消</el-button
        >
        <el-button
          type="primary"
          style="margin-left: 10px"
          @click="toFather"
          size="mini"
          >确定</el-button
        >
      </div>
    </span>
  </el-dialog>
</template>
<script>
import pagination from "@/components/pagination/pagination.vue";
import * as api from "@/server/api/mediaLibrary.js";
import { PlayCircleStrokeIcon, PlayIcon } from "tdesign-icons-vue";
export default {
  components: {
    pagination,
    PlayCircleStrokeIcon,
    PlayIcon,
  },
  props: {
    //发送文件详情
    fileDetail: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      visible: false,
      list: [],
      title: "选择图片",
      pageParams: {
        pageSize: 28,
        page: 1,
        content: "",
        type: "image",
      },
      radio: "",
      pageTotal: 20,
      multiple: [],
      isRadio: true,
      errorImg: require("@/assets/images/default_cover_16_9.png"),
      path: "/image",
      showLoading: false,
      multipleType: false,
      noDate: false,
      justMine: true, //只看我的
      adminId: "",
      videoPage: 1,
      imagePage: 1,
      audioPage: 1,
      tianchiyunPage: 1,
      allTypes: false,
      showVideo: false,
      showAudio: false,
      showImage: false,
      dirParentId: [],
      dirPage: [], //记录进入文件夹时当前的分页信息，返回时返回之前的页数、总数、和当前页的数据
    };
  },
  computed: {
    showBack() {
      // return this.path.lastIndexOf("/") !== 0;
      return this.dirParentId.length > 0;
    },
  },
  created() {
    this.adminId = JSON.parse(this.cookies.getCookie("user")).id;
  },
  methods: {
    //打开目录
    openDir(item) {
      this.dirPage.push({
        page: this.pageParams.page,
        total: this.pageTotal,
        data: this.list,
        keyword: this.pageParams.content,
        pageSize: this.pageParams.pageSize,
      });
      // this.path = item.path;
      this.dirParentId.push(item.id);
      this.pageParams.parentId = item.id;
      this.pageParams.page = 1;
      this.getList();
    },
    //返回上一级
    backDir() {
      let length = this.dirParentId.length;
      if (length > 0) {
        this.dirParentId.splice(-1, 1);
      }
      this.pageParams.parentId = this.dirParentId.slice(-1)[0] || 0;
      if (this.dirPage.length) {
        let obj = this.dirPage.splice(-1, 1)[0];
        this.pageParams.page = obj.page;
        this.pageParams.pageSize = obj.pageSize;
        this.pageTotal = obj.total;
        this.pageParams.content = obj.keyword;
        this.list = obj.data;
        this.noDate = false;
      } else {
        this.getList();
      }
    },
    toFather() {
      if (this.isRadio) {
        if (!this.radio) {
          this.info("未选择内容");
          return;
        } else {
          if (this.path == "/video") {
            if (!this.radio.transcodeUrl) {
              this.info("文件未转码，不支持引用");
              return;
            }
          }
          if (this.path == "/video" || this.path == "/audio") {
            if (this.multipleType || this.fileDetail) {
              this.$emit("change", {
                type: this.radio.type,
                url: this.radio.url,
                cover: this.radio.coverUrl,
                transcodeUrl: this.radio.transcodeUrl
                  ? this.radio.transcodeUrl
                  : "",
                taskId: this.radio.taskId ? this.radio.taskId : "",
              });
            } else {
              this.$emit("change", this.radio.url);
            }
          } else {
            let url = this.radio.url;
            if (this.multipleType || this.fileDetail) {
              this.$emit("change", {
                type: "image",
                url: url,
              });
            } else {
              this.$emit("change", url);
            }
          }
          this.visible = false;
        }
      } else {
        if (this.multiple.length == 0) {
          this.info("未选择内容");
          return;
        } else {
          for (let i = 0; i < this.multiple.length; i++) {
            if (this.multiple[i].type == 'video' && !this.multiple[i].transcodeUrl) {
              this.info("文件" + this.multiple[i].title + "未转码，不支持引用");
              return;
            }
          }
          this.$emit("change", this.multiple);
          this.visible = false;
        }
      }
    },
    changeType(type) {
      this.dirParentId = [];
      this.pageParams.parentId = 0;
      console.log("类型改变");
      this.setType(type);
    },
    setType(type) {
      this.type = type;
      if (this.type == "image" || this.type == "") {
        this.title = "选择图片";
        this.path = "/image";
        this.pageParams.type = "image";
      } else if (this.type == "video") {
        this.title = "选择视频";
        this.path = "/video";
        this.pageParams.type = "video";
      } else if (this.type == "audio") {
        this.title = "选择音频";
        this.path = "/audio";
        this.pageParams.type = "audio";
      } else {
        this.title = "选择图片";
        this.path = "/image";
        this.pageParams.type = "image";
      }
      if (this.path.indexOf("/image") === 0) {
        this.pageParams.page = this.imagePage;
      } else if (this.path.indexOf("/audio") === 0) {
        this.pageParams.page = this.audioPage;
      } else if (this.path.indexOf("/video") === 0) {
        this.pageParams.page = this.videoPage;
      } else if (this.path.indexOf("/tianchiyun") === 0) {
        this.pageParams.page = this.tianchiyunPage;
      }
      this.radio = "";
      this.multiple = [];
      this.getList();
    },
    //示例：
    //this.$refs.mediaVod.openModal("image", true, { allTypes: true, imageOrVideo:true,videoOrAudio:true,imageOrAudio:true});
    openModal(_type, method, option) {
      this.imagePage = 1;
      this.audioPage = 1;
      this.videoPage = 1;
      this.tianchiyunPage = 1;
      this.multipleType = false;
      this.showAudio = false;
      this.showImage = false;
      this.showVideo = false;
      this.setType(_type);
      this.isRadio = method === false ? false : true;
      this.visible = true;
      if (option && option.allTypes) {
        this.showVideo = true;
        this.showAudio = true;
        this.showImage = true;
        this.multipleType = true;
      } else if (option && option.imageOrVideo) {
        this.showVideo = true;
        this.showImage = true;
        this.multipleType = true;
      } else if (option && option.videoOrAudio) {
        this.showVideo = true;
        this.showAudio = true;
        this.multipleType = true;
      } else if (option && option.imageOrAudio) {
        this.showImage = true;
        this.showAudio = true;
        this.multipleType = true;
      }
    },
    getList() {
      // for (let a = 0; a < 28; a++) {
      //   let obj = {
      //     coverUrl:
      //       "hsp-dev-1258156964.cos.ap-guangzhou.myqcloud.com/saas/image/2022-09/9da75cf9-b989-4564-baaa-8f7199f3ed3d.jpg?sign=q-sign-algorithm%3Dsha1%26q-ak%3DAKIDreHfohOr57xb1CAxXyJajdIisnTu62i8%26q-sign-time%3D1669713360%3B1669972560%26q-key-time%3D1669713360%3B1669972560%26q-header-list%3Dhost%26q-url-param-list%3D%26q-signature%3D976fcd3de97c7e57c32a7af448a62adb9aa54a4d",
      //     title: "普通的图片,如果名字实在是太长了的话",
      //     type: "image",
      //   };
      //   this.list.push(obj);
      // }
      // return;
      let params = this.another(this.pageParams);
      //获取所有文件需要传content参数，就算为空
      // this.cleanObj(params);
      // if (params.content && this.path.lastIndexOf("/") !== 0) {
      //   this.path =
      //     "/" + this.path.substring(1, this.path.substring(1).indexOf("/") + 1);
      // }
      // params.path = this.path;
      if (this.justMine) {
        params.adminId = this.adminId;
      }
      console.log("搜索参数", params);

      // this.tableLoading = true;
      this.showLoading = true;
      this.noDate = false;
      api.list(params).then((resp) => {
        // console.log("文件列表", this.another(resp));
        if (resp.code === 0) {
          if (params.type != this.type) {
            return;
          }
          this.showLoading = false;

          if (resp.data.items) {
            resp.data.items.forEach((item) => {
              if (item.url) {
                if (item.url.indexOf("http") !== 0) {
                  item.url = "https://" + item.url;
                }
              }
              if (item.coverUrl) {
                if (item.coverUrl.indexOf("http") !== 0) {
                  item.coverUrl = "https://" + item.coverUrl;
                }
              }
            });
            this.list = resp.data.items;
            if (this.list.length == 0) {
              this.noDate = true;
            }
            this.pageTotal = resp.data.total;
            // console.log("处理后的列表", resp.data.items);
          } else {
            this.list = [];
            this.pageTotal = 0;
          }
        }
      });
    },
    imgError(item, str) {
      console.log("图片加载失败");
      item[str] = this.errorImg;
    },
    pageCallback(obj) {
      if (obj.code === "page") {
        //更改页码
        this.pageParams.page = obj.page;
        if (this.path.indexOf("/image") === 0) {
          this.imagePage = obj.page;
        } else if (this.path.indexOf("/audio") === 0) {
          this.audioPage = obj.page;
        } else if (this.path.indexOf("/video") === 0) {
          this.videoPage = obj.page;
        } else if (this.path.indexOf("/tianchiyun") === 0) {
          this.tianchiyunPage = obj.page;
        }
        this.getList();
      }
    },
    search() {
      this.dirParentId = [];
      this.pageParams.parentId = 0;
      this.pageParams.page = 1;
      this.dirPage = [];
      this.getList();
    },
    resetParams() {
      if (this.path.indexOf("/image") === 0) {
        this.imagePage = 1;
      } else if (this.path.indexOf("/audio") === 0) {
        this.audioPage = 1;
      } else if (this.path.indexOf("/video") === 0) {
        this.videoPage = 1;
      }
      //  else if (this.path.indexOf("/tianchiyun") === 0) {
      //   this.tianchiyunPage = 1;
      // }
      this.dirParentId = [];
      this.pageParams.parentId = 0;
      this.pageParams.page = 1;
      this.pageParams.content = "";
      this.dirPage = [];
      this.getList();
    },
    //点击标题或文件名预览
    viewItem(item) {
      // console.log("预览", item);
      let type = item.type;
      let options = ["image", "video", "audio", "dir"];
      if (options.indexOf(type) == -1) {
        this.info("此文件不支持预览，请下载后查看");
        return;
      }
      if (type == "dir") {
        this.openDir(item);
        return;
      } else {
        this.ShowImg(item.url, item.type);
      }
    },
  },
  //   props: ["type"],
  beforeMount() {},
};
</script>
<style lang="scss" scoped>
.chose-from-vod-wrap {
  width: 966px;
  position: relative;
  img {
    object-fit: contain;
  }
  .chose-from-vod-img-wrap {
    position: relative;
    // display: flex;
    // flex-wrap: wrap;
    // align-items: flex-start;
    display: inline-block;
  }
  .el-radio__label {
    white-space: normal !important;
  }
}
.chose-from-vod-wrap ::v-deep .el-radio__label {
  white-space: normal !important;
}
.chose-from-vod-dialog ::v-deep .el-dialog__body {
  padding: 0px !important;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
.chose-from-vod-dialog ::v-deep .el-radio__label {
  font-size: 12px !important;
}
.chose-from-vod-wrap ::v-deep .form-check-label {
  font-size: 12px !important;
}
::v-deep .el-app-pagination {
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}
</style>
